import { Deserializable } from '../protocols/deserializable';
import { JurisdictionCommutableThreshold } from './jurisdiction-commutable-threshold';

export class JurisdictionCommutableThresholdWrapper implements Deserializable {
  public definedContribution!: JurisdictionCommutableThreshold | null;

  public onDeserialize() {
    this.definedContribution = this.definedContribution
      ? window.injector.Deserialize.instanceOf(JurisdictionCommutableThreshold, this.definedContribution)
      : null;
  }
}
